
const crvBreakpoints = ['sm', 'md', 'lg', 'xl', 'xxl'];

const makeKey = (name, bp) => {
  return `${name}_${bp}`;
}

const injectBreakpoint = (styles, breakpoint) => {
  return Object.fromEntries(
    Object.entries(styles).map(([key, css]) => [[key], { [breakpoint]: css }]),
  );
};

export const crv = (name, styles) => {
  if (!name) return;

  const variants = {
    [name]: styles,
  };

  for (const bp of crvBreakpoints) {
    variants[makeKey(name, bp)] = injectBreakpoint(styles, bp);
  }

  return variants;
};

export const splitResponsiveVariant = (name, value) => {
  if (typeof value !== 'object') {
    return { [name]: value };
  }

  const { base, ...rest } = value;
  let variants = { [name]: base };

  for (const bp of crvBreakpoints) {
    if (!(bp in rest)) continue;
    variants[makeKey(name, bp)] = rest[bp];
  }

  return variants;
};

export const splitCrv = splitResponsiveVariant;


const groupByBreakpoint = (variants) => {
  const result = {};

  for (const bp of crvBreakpoints) {
    let renamed = {};
    for (const [key, value] of Object.entries(variants)) {
      renamed[makeKey(key, bp)] = value;
    }
    result[bp] = renamed;
  }
  return Object.entries(result);
};

export const ccv = (args) => {
  const { css, ...variants }  = args;
  if (!variants || !css) return [];

  const compoundVariants = [{ ...variants, css }];

  for (const [bp, keys] of groupByBreakpoint(variants)) {
    compoundVariants.push({ ...keys, css: { [bp]: css } });
  }

  return compoundVariants;
};
